import { render, staticRenderFns } from "./CreatePromoCodes.vue?vue&type=template&id=64893273"
import script from "./CreatePromoCodes.vue?vue&type=script&lang=js"
export * from "./CreatePromoCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports